import React from 'react';
import useDetailTripPlan from '../detail-trip-plan.hooks';
import { t } from 'i18next';
import { convertToRibuan } from '../../../../../../util/Util';
import { ValueNumberType } from '../../../../../../component/moleculs/detail-values';

const TabReview = () => {
  const {
    outsource,
    owned,
    whole
  } = useDetailTripPlan();

  return (
    <div className='flex'>
      <div className='gap-[40px] mb-[24px]'>

        {/* Tab Title Outsource */}
        <h3 className="font-roboto text-[18px] font-semibold mt-2 w-[500px] mb-[24px]">
          {t("Trip Planning Detail - Outsource")}
        </h3>

        {/* Tab Content 1 Outsource */}
        <div className="flex">
          {/* //one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Weight ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.left_capacity_weight_outsource ? outsource?.left_capacity_weight_outsource : '0'} Kg
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Volume of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.utilized_capacity_volume_outsource ? outsource?.utilized_capacity_volume_outsource : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Cost ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
              IDR {outsource?.total_cost_outsourced ? convertToRibuan(outsource?.total_cost_outsourced) : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("No of Trip Created ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
              {outsource?.no_of_trip_created_outsource ? outsource?.no_of_trip_created_outsource : ''} Trip
              </h4>
            </div>
          </div>
          {/* line two */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Weight of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
              {outsource?.utilized_capacity_weight_outsource ? outsource?.utilized_capacity_weight_outsource : '0'} kg
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Unit ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.left_capacity_unit_outsource ? outsource?.left_capacity_unit_outsource : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Estimation Time ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.total_estimation_time_outsourced ? outsource?.total_estimation_time_outsourced : '0'} Min
              </h4>
            </div>
          </div>
          {/* line three */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Volume ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.left_capacity_volume_outsource ? outsource?.left_capacity_volume_outsource : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Unit of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.utilized_capacity_unit_outsource ? outsource?.utilized_capacity_unit_outsource : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Distance ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {outsource?.total_distance_outsourced ? convertToRibuan(outsource?.total_distance_outsourced) : '0'} M
              </h4>
            </div>
          </div>
        </div>

        {/* Tab Title Owned */}
        <h3 className="font-roboto text-[18px] font-semibold mt-2 w-[500px] mb-[24px]">
          {t("Trip Planning Detail - Owned")}
        </h3>

        {/* Tab Content 2 Owned */}
        <div className="flex">
          {/* //one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Weight ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.left_capacity_weight_owned ? owned?.left_capacity_weight_owned : '0'} Kg
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Volume of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.utilized_capacity_volume_owned ? owned?.utilized_capacity_volume_owned : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Cost ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                IDR {owned?.total_cost_owned ? convertToRibuan(owned?.total_cost_owned) : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("No of Trip Created ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.no_of_trip_created_owned ? owned?.no_of_trip_created_owned : '0'} Trip
              </h4>
            </div>
          </div>
          {/* line two */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Weight of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.utilized_capacity_weight_owned ? owned?.utilized_capacity_weight_owned : '0'} Kg
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Unit ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.left_capacity_unit_owned ? owned?.left_capacity_unit_owned : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Estimation Time ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.total_estimation_time_owned ? convertToRibuan(owned?.total_estimation_time_owned) : '0'} Min
              </h4>
            </div>
          </div>
          {/* line three */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Volume ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.left_capacity_volume_owned ? owned?.left_capacity_volume_owned : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Unit of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.utilized_capacity_unit_owned ? owned?.utilized_capacity_unit_owned : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Distance ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {owned?.total_distance_owned ? convertToRibuan(owned?.total_distance_owned) : '0'} M
              </h4>
            </div>
          </div>
        </div>

        {/* Tab Title Whole */}
        <h3 className="font-roboto text-[18px] font-semibold mt-2 w-[500px] mb-[24px]">
          {t("Detail of the whole Trip Planning")}
        </h3>

        {/* Tab Content 3 Whole */}
        <div className="flex">
          {/* //one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Weight ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {whole?.left_capacity_weight ? whole?.left_capacity_weight : '0'} Kg
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Volume of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {whole?.utilized_capacity_volume ? whole?.utilized_capacity_volume : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Cost ")}
              </label>
              <ValueNumberType value={whole?.total_cost} before="IDR" />
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("No of Trip Created ")}
              </label>
              <ValueNumberType value={whole?.no_of_trip_created} after="Trip" />
            </div>
          </div>
          {/* line two */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Weight of Trip Planning ")}
              </label>
              <ValueNumberType value={whole?.utilized_capacity_weight} after="Kg" />
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Unit ")}
              </label>
              <ValueNumberType value={whole?.left_capacity_unit} />
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Estimation Time ")}
              </label>
              <ValueNumberType value={whole?.total_estimation_time} after="Min" />
            </div>
          </div>
          {/* line three */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Left Capacity Volume ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {whole?.left_capacity_volume ? whole?.left_capacity_volume : '0'} m<sup>3</sup>
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Unit of Trip Planning ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {whole?.utilized_capacity_unit ? whole?.utilized_capacity_unit : '0'}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Total Distance ")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {whole?.total_distance ? convertToRibuan(whole?.total_distance) : '0'} M
              </h4>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default TabReview;